/**
 * Display flow-level messages from Kratos.
 */

import type { UiText } from '@ory/client';

interface FlowMessagesProps {
  messages?: UiText[];
}

export default function FlowMessages({ messages }: FlowMessagesProps) {
  if (!messages || messages.length === 0) {
    return null;
  }

  return (
    <div className="space-y-2 mb-4">
      {messages.map((message, index) => (
        <div
          key={index}
          className={`px-4 py-3 rounded-lg text-sm ${
            message.type === 'error'
              ? 'bg-red-50 dark:bg-red-900/30 text-red-700 dark:text-red-300 border border-red-200 dark:border-red-800'
              : message.type === 'success'
                ? 'bg-green-50 dark:bg-green-900/30 text-green-700 dark:text-green-300 border border-green-200 dark:border-green-800'
                : 'bg-blue-50 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300 border border-blue-200 dark:border-blue-800'
          }`}
        >
          {message.text}
        </div>
      ))}
    </div>
  );
}
